import { Minus, Plus, Trash2, ShoppingCart } from "lucide-react";

const fmt = (n) => new Intl.NumberFormat("fr-FR").format(n);

export const CartItemsList = ({ items, onQty, readOnly = false }) => (
  <ul className="space-y-3" data-testid="cart-items-list">
    {items.map((i) => (
      <li key={i.product_id} className="flex gap-3 items-center bg-[#0F172A] border border-white/10 rounded-2xl p-3" data-testid={`cart-item-${i.product_id}`}>
        {i.image_url ? (
          <img src={i.image_url} alt={i.name} className="w-14 h-14 rounded-xl object-cover flex-shrink-0" />
        ) : (
          <div className="w-14 h-14 rounded-xl bg-white/5 flex items-center justify-center flex-shrink-0">
            <ShoppingCart className="w-5 h-5 text-white/30" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-white line-clamp-2 break-words">{i.name}</p>
          <p className="text-xs text-white/50">{fmt(i.price)} FCFA × {i.quantity}</p>
          <p className="text-sm font-black text-[#D4AF37]" data-testid={`cart-item-total-${i.product_id}`}>{fmt(i.price * i.quantity)} FCFA</p>
        </div>
        {!readOnly && (
          <div className="flex items-center gap-1">
            <button type="button" onClick={() => onQty(i.product_id, i.quantity - 1)} className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid={`cart-decrease-${i.product_id}`}>
              {i.quantity === 1 ? <Trash2 className="w-3.5 h-3.5 text-red-400" /> : <Minus className="w-3.5 h-3.5 text-white" />}
            </button>
            <span className="w-6 text-center text-sm font-black text-white" data-testid={`cart-qty-${i.product_id}`}>{i.quantity}</span>
            <button type="button" onClick={() => onQty(i.product_id, i.quantity + 1)} className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid={`cart-increase-${i.product_id}`}>
              <Plus className="w-3.5 h-3.5 text-white" />
            </button>
          </div>
        )}
      </li>
    ))}
  </ul>
);
